import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { campaignApi } from "../../api/campaignApi";
import toast from 'react-hot-toast';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useEffect, useState, useCallback } from "react";
import * as React from 'react';
import * as Yup from 'yup';
import { alpha } from '@mui/material/styles';
import { grey } from '../../theme/tones';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DialogManageCommercials = (propsData) => {
  const theme = useTheme();
  const { setIsLoading, idCampaign, isLoading, openManageCommercials, commercialsCampaignManageNotTreated, commercialsCampaignManage,
    setOpenManageCommercials } = propsData;

  const [displayCommercialToManage, setDisplayCommercialToManage] = useState(false);
  const [displayCommercialToTakeCustomers, setDisplayCommercialToTakeCustomers] = useState(false);
  const [displayNumberCustomersManage, setDisplayNumberCustomersManage] = useState(false);
  const [selectEquitableManage, setSelectEquitableManage] = useState(false);
  const [selectedCommercialToTakeCustomers, setSelectedCommercialToTakeCustomers] = useState({ firstname: '', lastname: '', id: 0 });
  const [commercialsCampaignToTakeCustomers, setCommercialsCampaignToTakeCustomers] = useState([]);
  const [commercialsCampaignToManage, setCommercialsCampaignToManage] = useState([]);
  const [selectedCommercialToManage, setSelectedCommercialToManage] = useState({ firstname: '', lastname: '', id: 0 });
  const [nbCustomersManage, setNbCustomersManage] = useState(0);

  useEffect(() => {
    setCommercialsCampaignToTakeCustomers((commercialsCampaignManageNotTreated || []).filter((el) => (selectedCommercialToManage === null ? el : el.id !== selectedCommercialToManage.id)));
    setCommercialsCampaignToManage((commercialsCampaignManage || []).filter((el) => (selectedCommercialToTakeCustomers === null ? el : el.id !== selectedCommercialToTakeCustomers.id)));
  }, [commercialsCampaignManage, commercialsCampaignManageNotTreated, selectedCommercialToManage, selectedCommercialToTakeCustomers]);

  const handleLeavingDialogManageCommercial = useCallback(() => {
    if (!openManageCommercials) {
      setDisplayCommercialToManage(false);
      setDisplayCommercialToTakeCustomers(false);
      setDisplayNumberCustomersManage(false);
      setSelectEquitableManage(false);
      setSelectedCommercialToTakeCustomers({ firstname: '', lastname: '', id: 0 });
      setSelectedCommercialToManage({ firstname: '', lastname: '', id: 0 });
    }
  }, [openManageCommercials]);

  const initialValuesManageCommercials = {
    choiceCommercialToAddCustomers: { firstname: '', lastname: '' },
    choiceCommercialToTakeCustomers: { firstname: '', lastname: '' },
    typeManage: '',
    nbCustomersManage: 0
  };

  const validationSchemaManageCommercials = Yup
    .object()
    .shape({
      choiceCommercialToAddCustomers: Yup.object(),
      choiceCommercialToTakeCustomers: Yup.object(),
      typeManage: Yup.string().required('Un type de remaniement est requis'),
      nbCustomersManage: Yup.number().when('choiceCommercialToTakeCustomers', (commercial) => (commercial === null || Object.keys(commercial).length === 0 ? Yup.number() : Yup.number().max(commercial.nbNotTreated, 'Nombre trop grand'))),
    });

  useEffect(() => {
    handleLeavingDialogManageCommercial();
  }, [openManageCommercials, handleLeavingDialogManageCommercial]);

  return (
    <Dialog
      open={openManageCommercials}
      onClose={() => setOpenManageCommercials(false)}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: '20px', p: 1 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>Gérer les commerciaux</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={initialValuesManageCommercials}
          validationSchema={validationSchemaManageCommercials}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              setIsLoading(true);
              await campaignApi.manageCommercials(idCampaign, values, localStorage.getItem('accessToken'));
              setStatus({ success: true });
              setSubmitting(false);
              toast.success('Remaniement des commerciaux effectué avec succès');
              setOpenManageCommercials(false);
              setIsLoading(false);
              window.location.reload(false);
            } catch (err) {
              console.error(err);
              toast.error('Il y a eu un souci lors du remaniement des commerciaux !');
              setStatus({ success: false });
              setErrors({ submit: err.message });
              setSubmitting(false);
              setIsLoading(false);
            }
          }}
        >
          {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Box sx={{ mt: 1.5 }}>
                <FormControl component="fieldset" fullWidth sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: theme.palette.text.secondary }}>
                    Type de remaniement
                  </Typography>
                  <RadioGroup
                    row
                    name="typeManage"
                    value={values.typeManage}
                    onChange={(e) => {
                      const val = e.target.value;
                      setFieldValue('typeManage', val);
                      if (val === 'Équitable') {
                        setDisplayCommercialToManage(false);
                        setDisplayCommercialToTakeCustomers(false);
                        setDisplayNumberCustomersManage(false);
                        setSelectEquitableManage(true);
                        setFieldValue('choiceCommercialToAddCustomers', {});
                        setFieldValue('choiceCommercialToTakeCustomers', {});
                      } else if (val === 'Réattribution') {
                        setDisplayCommercialToManage(true);
                        setDisplayCommercialToTakeCustomers(true);
                        setDisplayNumberCustomersManage(true);
                        setSelectEquitableManage(false);
                        setFieldValue('choiceCommercialToAddCustomers', { firstname: '', lastname: '' });
                        setFieldValue('choiceCommercialToTakeCustomers', { firstname: '', lastname: '' });
                      }
                    }}
                  >
                    <FormControlLabel
                      value="Équitable"
                      control={<Radio />}
                      label="Équitable"
                    />
                    <FormControlLabel
                      value="Réattribution"
                      control={<Radio />}
                      label="Réattribution"
                    />
                  </RadioGroup>
                </FormControl>

                {errors.typeManage && touched.typeManage && (
                  <Typography color="error" variant="caption" sx={{ display: 'block', mb: 2 }}>
                    {errors.typeManage}
                  </Typography>
                )}
                {errors.nbCustomersManage && (
                  <Typography color="error" variant="caption" sx={{ display: 'block', mb: 2 }}>
                    {errors.nbCustomersManage}
                  </Typography>
                )}

                <Grid container spacing={3}>
                  {displayCommercialToTakeCustomers && (
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        id="checkboxes-tags-manage-commercial-to-take"
                        options={commercialsCampaignToTakeCustomers || []}
                        value={values.choiceCommercialToTakeCustomers}
                        onChange={(e, value) => {
                          setFieldValue('choiceCommercialToTakeCustomers', value);
                          setSelectedCommercialToTakeCustomers(value);
                          if (value !== null) {
                            setFieldValue('nbCustomersManage', value.nbNotTreated);
                          } else {
                            setFieldValue('nbCustomersManage', 0);
                          }
                        }}
                        getOptionLabel={(option) => (option.firstname ? `${option.firstname} ${option.lastname}` : '')}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {`${option.firstname} ${option.lastname} (non traités : ${option.nbNotTreated})`}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Commercial auquel on prend"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: { borderRadius: '12px' }
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}

                  {displayNumberCustomersManage && (
                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        label="Nombre de prospects à transférer"
                        type="number"
                        onChange={(event) => {
                          const val = parseInt(event.target.value, 10) || 0;
                          values.nbCustomersManage = val;
                          setNbCustomersManage(val);
                        }}
                        value={values.nbCustomersManage}
                        variant="outlined"
                        InputProps={{ 
                          inputProps: { max: nbCustomersManage, min: 0 },
                          sx: { borderRadius: '12px' } 
                        }}
                      />
                    </Grid>
                  )}

                  {displayCommercialToManage && (
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        id="checkboxes-tags-manage-commercial-to-give"
                        options={commercialsCampaignToManage || []}
                        value={values.choiceCommercialToAddCustomers}
                        onChange={(_, value) => {
                          setFieldValue('choiceCommercialToAddCustomers', value);
                          setSelectedCommercialToManage(value);
                        }}
                        getOptionLabel={(option) => (option.firstname ? `${option.firstname} ${option.lastname}` : '')}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {`${option.firstname} ${option.lastname}`}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Commercial auquel on attribue"
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              sx: { borderRadius: '12px' }
                            }}
                          />
                        )}
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1.5, pt: 3, pb: 1 }}>
                <Button
                  onClick={() => setOpenManageCommercials(false)}
                  color="inherit"
                  variant="outlined"
                  sx={{ borderRadius: '10px', textTransform: 'none', fontWeight: 600, borderColor: 'divider' }}
                >
                  Annuler
                </Button>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  disabled={isSubmitting || (selectedCommercialToManage == null && !selectEquitableManage) || (selectedCommercialToTakeCustomers === null && !selectEquitableManage) || (selectedCommercialToManage.firstname === '' && selectedCommercialToManage.lastname === '' && !selectEquitableManage) || (selectedCommercialToTakeCustomers.firstname === '' && selectedCommercialToTakeCustomers.lastname === '' && !selectEquitableManage)}
                  sx={{
                    background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`,
                    color: grey(0),
                    borderRadius: '10px',
                    px: 3,
                    textTransform: 'none',
                    fontWeight: 600,
                    boxShadow: (theme) => `0 4px 12px 0 ${alpha(theme.palette.secondary.main, 0.25)}`,
                    '&:hover': {
                      background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.dark} 100%)`
                    }
                  }}
                >
                  Enregistrer
                </Button>
                {isLoading && (
                  <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    <CircularProgress size={24} />
                  </Box>
                )}
              </Box>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default DialogManageCommercials;
